var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('vue-google-autocomplete',{ref:"address",staticClass:"places",attrs:{"id":'map'+_vm.id,"classname":"form-control","placeholder":_vm.placeHolder || _vm.$t('profile.type_address'),"value":_vm.placeAddress},on:{"placechanged":($addressData, $placeResultData, $id) => _vm.addressDataHanddler({
                $addressData,
                $id,
                $placeResultData
            }),"inputChange":_vm.handleInput,"blur":_vm.handleBlur}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }